// @ts-nocheck
import { WorkflowCompletionConfig } from './consts'

export const selectWorkflowCompletionConfig = (state) => {
  const completedWorkflow = state.completion.completedWorkflow
  if (!completedWorkflow) return {}
  const workflow =
    typeof completedWorkflow === 'string' ? completedWorkflow : completedWorkflow.workflow
  const context = completedWorkflow?.context ?? 'default'
  const workflowConfig =
    WorkflowCompletionConfig[workflow]?.[context] ?? WorkflowCompletionConfig[workflow]
  return workflowConfig
}
